module.exports = __webpack_public_path__ + "img/61.4f907b40.png";